angular.module('directives.dashboard').directive('wgtInfoSaleBusinessArea', ['DashboardApiService', 'googleChartApiPromise',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtInfoSaleBusinessArea/wgtInfoSaleBusinessArea.tpl.html',
                link: function ($scope, $element, googleChartApiPromise) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.widgetData = response.data;
                                if(angular.isString($scope.item.setting)){
                                    $scope.item.setting = JSON.parse($scope.item.setting);
                                }
                                $scope.selectedWidgetTimeFrame = $scope.item.setting === undefined ? 0 : $scope.item.setting.selectedWidgetTimeFrame;
                                setTimeout(() => {
                                    google.charts.setOnLoadCallback($scope.drawChart);
                                }, 250);

                                $scope.isLoaded = true;
                                $scope.hasError = false;
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };
                    $scope.formatHtmlTooltip = function (data) {
                        return "<div " + 
                            "class=\"pieChartBA\">" + "<b>" + data.businessArea.name+"</b>" + "<br>" + 
                            data.totalSalesPrice.toLocaleString() + ": (" + (data.totalSalesPercent * 100).toFixed(1) + "%)" + 
                        "</div>"
                    }
                    $scope.drawChart = function() {

                        var dataArray = [];
                        _.forEach($scope.widgetData.salesBusinessAreaData, function(data) {
                            dataArray.push([
                                data.businessArea.name, 
                                parseFloat(data.totalSalesPrice), 
                                $scope.formatHtmlTooltip(data)
                            ])
                        });

                        var dataTable = new google.visualization.DataTable();
                        dataTable.addColumn("string", "BusinessArea");
                        dataTable.addColumn("number","TotalSales");
                        dataTable.addColumn({type: "string", role: "tooltip", p: {'html': true}});
                        dataTable.addRows(dataArray);

                        var options = {
                            chartArea: {left:15,top:30},
                            width:600,
                            height:300,
                            fontSize: 11,
                            isStacked: true,
                            sliceVisibilityThreshold: 0,
                            is3D: true,
                            tooltip: {
                                showColorCode : true,
                                isHtml : true
                            }
                        };

                        $scope.chart = new google.visualization.PieChart(document.getElementById("pieChart-" + $scope.$id));

                        $scope.chart.draw(dataTable, options);
                    };
                    $scope.loadWidget();
                }
            };
        }]
);
